import type { CSSProperties, ReactNode } from 'react';
import type { EventoTema } from '@eventos-cien/shared';

interface Props {
  /** Paleta del evento activo. Si falta un color, se hereda el token base (navy/oro/fondo). */
  tema: EventoTema | null | undefined;
  children: ReactNode;
}

/**
 * Inyecta el tema de un evento como variables CSS (--evento-primario/
 * secundario/terciario) sobre el subarbol que envuelve. Nunca envuelve el
 * shell completo de la app (Sidebar/Topbar): esos siempre se ven navy/oro
 * sin importar que evento este abierto. Ver frontend/src/styles/index.css
 * para los valores por defecto de esas variables.
 */
export function ThemeProvider({ tema, children }: Props) {
  const style: CSSProperties | undefined = tema
    ? {
        ...(tema.primario ? { ['--evento-primario' as string]: tema.primario } : {}),
        ...(tema.secundario ? { ['--evento-secundario' as string]: tema.secundario } : {}),
        ...(tema.terciario ? { ['--evento-terciario' as string]: tema.terciario } : {}),
      }
    : undefined;

  return <div style={style}>{children}</div>;
}
